import React, { PropsWithChildren } from 'react'
import { remCalc } from 'utils'

const LIST_ICON_STYLES =
  'flex justify-center items-center w-6 p-0 m-0 text-primary content-center'
const LIST_ICON_INLINE_STYLES = { flex: `0 0 ${remCalc(24)}` }

export const ListIcon: React.FC<PropsWithChildren> = ({ children }) => (
  <p className={LIST_ICON_STYLES} style={LIST_ICON_INLINE_STYLES}>
    {children}
  </p>
)

ListIcon.displayName = 'Content.ListIcon'
